import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadCarouselProducts from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import {
    getErrorMessage,
    getProductsForProductInfoList,
} from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import surLoadCarouselProductWithIds from "@tSurya/Handlers/SurLoadCarouselProductWithIds";
import CustomChevronLeft from "@tSurya/Icons/CustomChevronLeft";
import CustomChevronRight from "@tSurya/Icons/CustomChevronRight";
import BaseStyledLink from "@tSurya/theme/components/StyledLink";
import { ELEMENTS } from "@tSurya/theme/design";
import GVLeftArrow from "@tSurya/theme/styleguide/icons/GVLeftArrow";
import GVRightArrow from "@tSurya/theme/styleguide/icons/GVRightArrow";
import { isThemeActive, THEME_IDS } from "@tSurya/theme/themeHelper";
import SurProductListProductGridCrad from "@tSurya/Widgets/Product/SurProductListProductGridCrad";
import useEmblaCarousel from "embla-carousel-react";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";
import styled from "styled-components";

// extend the shared StyledLink with custom product carousel specific styling
const StyledLearnMoreLink = styled(BaseStyledLink)`
    background: transparent !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 0 !important;
    margin-top: 8px;
`;

const enum fields {
    title = "title",
    numberOfProductsToDisplay = "numberOfProductsToDisplay",
    maxNumberOfColumns = "maxNumberOfColumns",
    showImage = "showImage",
    showTitle = "showTitle",
    showBrandName = "showBrandName",
    showPartNumbers = "showPartNumbers",
    showPrice = "showPrice",
    showAddToCart = "showAddToCart",
    showAddToList = "showAddToList",
    showProductDescription = "showProductDescription",
    cssClass = "cssClass",
    productidlist = "productidlist",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.numberOfProductsToDisplay]: number;
        [fields.maxNumberOfColumns]: number;
        [fields.showImage]: boolean;
        [fields.showTitle]: boolean;
        [fields.showBrandName]: boolean;
        [fields.showPartNumbers]: boolean;
        [fields.showPrice]: boolean;
        [fields.showAddToCart]: boolean;
        [fields.showAddToList]: boolean;
        [fields.showProductDescription]: boolean;
        [fields.productidlist]: string;
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    return {
        products: getProductsForProductInfoList(state, ownProps.id),
        errorMessage: getErrorMessage(state, ownProps.id),
        pageType: getCurrentPage(state).type,
    };
};

const mapDispatchToProps = {
    loadCarouselProducts,
    surLoadCarouselProductWithIds,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme> &
    HasShellContext;

export interface ProductCarouselStyles {
    errorMessageText?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    skipCarouselButton?: SkipNavStyles;
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonPresentationProps;
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    carouselProductStyles?: ProductCarouselStyles;
    customproducttilewrapper?: InjectableCss;
    wrapper?: InjectableCss;
    carouselProductWrapper?: InjectableCss;
    carouselItemWrapper?: InjectableCss;
    carouselItemOverlay?: InjectableCss;
    carouselItemTitle?: TypographyPresentationProps;
    carouselLearnMoreLink?: InjectableCss;
    prevArrowWrapper?: InjectableCss;
    nextArrowWrapper?: InjectableCss;
}

export const productCarouselStyles: ProductCarouselStyles = {
    errorMessageText: {
        color: "danger",
        css: css`
            margin-top: 20px;
        `,
    },
    carouselProductStyles: {
        carouselGridItem: {
            css: css`
                /* border: 1px solid red; */
            `,
        },
    },
    titleText: {
        variant: "h2",
        css: css`
            text-align: center;
            margin-bottom: 72px;
            color: #262525;
            font-weight: 800;
            font-size: 40px;
            line-height: 48px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-weight: 600;
                            font-size: 24px;
                            line-height: 32px;
                            margin-bottom: 24px;
                        `,
                        css`
                            font-weight: 600;
                            font-size: 24px;
                            line-height: 32px;
                            margin-bottom: 24px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    mainContainer: {
        gap: 0,
        css: css`
            max-width: 100% !important;
        `,
    },

    customproducttilewrapper: {
        css: css`
            margin: 0 auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-bottom: 30px;
                            // margin-right: -20px;
                            // margin-left: -20px;
                        `,
                        css`
                            padding-bottom: 30px;
                        `,
                        css`
                            padding-bottom: 30px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    prevArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-start;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: 25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: 25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: 25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: 25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: 25px;
                    `,
                ])}
        `,
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: none;
            padding: 0;
            background-color: transparent;
            width: ${ELEMENTS.carouselArrows.size};
            height: ${ELEMENTS.carouselArrows.size};
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: ${ELEMENTS.carouselArrows.boxShadow};
            flex-shrink: 0;
            min-width: ${ELEMENTS.carouselArrows.size};
            min-height: ${ELEMENTS.carouselArrows.size};
            // padding: ${ELEMENTS.carouselArrows.padding};
            border-radius: 50%;
            > span {
                top: ${ELEMENTS.carouselArrows.iconTop} !important;
            }
            &:hover {
                background: transparent;
                border: none;
            }
            &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
        `,
    },
    nextArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: -25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: -25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: -25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: -25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: -25px;
                    `,
                ])}
        `,
    },
    nextArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: none;
            padding: 0;
            background-color: transparent;
            width: ${ELEMENTS.carouselArrows.size};
            height: ${ELEMENTS.carouselArrows.size};
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: ${ELEMENTS.carouselArrows.boxShadow};
            flex-shrink: 0;
            min-width: ${ELEMENTS.carouselArrows.size};
            min-height: ${ELEMENTS.carouselArrows.size};
            // padding: ${ELEMENTS.carouselArrows.padding};
            border-radius: 50%;
            > span {
                top: ${ELEMENTS.carouselArrows.iconTop} !important;
            }
            &:hover {
                background: transparent;
                border: none;
            }
            &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
        `,
    },
    carouselGridItem: {
        width: 10,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                ])}
        `,
    },
    carouselWrapper: {
        css: css`
            width: 100%;
            position: relative;
        `,
    },
    carouselContainer: {
        css: css`
            overflow: hidden;
        `,
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: nowrap;
                        justify-content: space-between;
                        gap: 10px;
                    `,
                    css`
                        flex-wrap: nowrap;
                        justify-content: space-between;
                        gap: 10px;
                    `,
                    css`
                        flex-wrap: nowrap;
                        justify-content: space-between;
                        gap: 10px;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    carouselSlide: {
        css: css`
            padding: 0;
            position: relative;
            flex: 0 0 auto;
            margin-top: 5px;
            padding-right: 12px;
            padding-left: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: calc(50% - 5px) !important;
                        padding: 0;
                    `,
                    css`
                        width: calc(50% - 5px) !important;
                        padding: 0;
                    `,
                    css`
                        width: calc(50% - 5px) !important;
                        padding: 0;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    carouselSlideInner: {
        css: css`
            width: 100%;
            height: 100%;
            position: relative;
            padding: 0 2px;
            display: flex;
            flex-direction: column;
        `,
    },
    wrapper: {
        css: css`
            padding-bottom: 61px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 36px;
                    `,
                    css`
                        padding-bottom: 36px;
                    `,
                    css`
                        padding-bottom: 36px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    carouselProductWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            position: relative;
        `,
    },
    carouselItemWrapper: {
        css: css`
            position: relative;
            width: 100%;
            height: 100%;
        `,
    },
    carouselItemOverlay: {
        css: css`
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background:
                linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%),
                url(<path-to-image>) lightgray 50% / cover no-repeat;
            opacity: 0;
            transition: opacity 0.3s ease-in-out;
            display: flex;
            align-items: flex-end;
            padding: 20px;
            z-index: 2;
        `,
    },
    carouselItemTitle: {
        color: "#FFFFFF",
        variant: "h6",
        css: css`
            font-size: 16px;
            font-weight: 600;
            line-height: 1.4;
            margin: 0;
        `,
    },
    carouselLearnMoreLink: {
        css: css`
            display: none; /* Hidden by default, only shown in Global Views */
        `,
    },
    prevArrowWrapper: {
        css: css`
            position: absolute;
            left: 8px;
            top: 50%;
            transform: translateY(-50%);
            z-index: 10;
        `,
    },
    nextArrowWrapper: {
        css: css`
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translateY(-50%);
            z-index: 10;
        `,
    },
};

const getThemeAwareStyles = (isGlobalViews: boolean): ProductCarouselStyles => {
    const baseStyles = productCarouselStyles;

    if (isGlobalViews) {
        // override styles for GV theme
        return {
            ...baseStyles,
            titleText: {
                ...baseStyles.titleText,
                css: css`
                    ${baseStyles.titleText?.css}
                    font-family: 'Fraunces-72pt', serif;
                    font-style: italic;
                    font-weight: 100;
                `,
            },
            carouselItemWrapper: {
                css: css`
                    position: relative;
                    width: 100%;
                    height: 100%;
                    cursor: pointer;

                    &:hover .carousel-item-overlay {
                        opacity: 1;
                    }

                    .product-title,
                    [data-test-selector="productTitle"],
                    [data-test-selector*="addToList"] {
                        display: none !important;
                    }
                `,
            },
            carouselItemOverlay: {
                css: css`
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
                    opacity: 0;
                    transition: opacity 0.3s ease-in-out;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    align-items: flex-start;
                    padding: 20px 20px 28px;
                    z-index: 2;
                    pointer-events: none;
                `,
            },
            carouselItemTitle: {
                color: "#FFFFFF",
                variant: "h4",
                css: css`
                    margin-bottom: 0;
                    font-weight: 400;
                `,
            },
            carouselLearnMoreLink: {
                css: css`
                    margin-top: 0;
                    pointer-events: auto;
                    font-size: 14px;
                    font-weight: 600;
                `,
            },
            carouselSlide: {
                ...baseStyles.carouselSlide,
                css: css`
                    position: relative;
                    flex: 0 0 auto;
                    margin-top: 5px;

                    @media (max-width: 767px) {
                        flex: 0 0 calc(100% - 40px);
                        max-width: calc(100% - 40px);
                        width: auto !important;
                    }
                `,
            },
            carouselWrapper: {
                ...baseStyles.carouselWrapper,
            },
            carouselContainer: {
                ...baseStyles.carouselContainer,
            },
            carouselSlidesContainer: {
                ...baseStyles.carouselSlidesContainer,
                css: css`
                    display: flex;
                    flex-wrap: nowrap;
                    justify-content: flex-start;
                    width: 100%;

                    @media (max-width: 767px) {
                        width: 100%;
                    }

                    > * {
                        margin-right: 20px;

                        @media (max-width: 767px) {
                            margin-right: 16px;
                        }
                    }
                `,
            },
            // GV carousel arrows
            prevArrowWrapper: {
                css: css`
                    position: absolute;
                    left: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 10;
                `,
            },
            nextArrowWrapper: {
                css: css`
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 10;
                `,
            },
            prevArrowButton: {
                ...baseStyles.prevArrowButton,
                css: css`
                    background-color: #ffffff;
                    border: ${ELEMENTS.carouselArrows.border};
                    width: ${ELEMENTS.carouselArrows.size};
                    height: ${ELEMENTS.carouselArrows.size};
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: ${ELEMENTS.carouselArrows.boxShadow};
                    flex-shrink: 0;
                    min-width: ${ELEMENTS.carouselArrows.size};
                    min-height: ${ELEMENTS.carouselArrows.size};
                    padding: ${ELEMENTS.carouselArrows.padding};
                    > span {
                        top: ${ELEMENTS.carouselArrows.iconTop} !important;
                    }
                    &:hover {
                        background: #ffffff;
                        border: ${ELEMENTS.carouselArrows.border};
                    }
                    &:disabled {
                        display: none;
                    }
                `,
            },
            nextArrowButton: {
                ...baseStyles.nextArrowButton,
                css: css`
                    background-color: #ffffff;
                    border: ${ELEMENTS.carouselArrows.border};
                    width: ${ELEMENTS.carouselArrows.size};
                    height: ${ELEMENTS.carouselArrows.size};
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: ${ELEMENTS.carouselArrows.boxShadow};
                    flex-shrink: 0;
                    min-width: ${ELEMENTS.carouselArrows.size};
                    min-height: ${ELEMENTS.carouselArrows.size};
                    padding: ${ELEMENTS.carouselArrows.padding};
                    > span {
                        top: ${ELEMENTS.carouselArrows.iconTop} !important;
                    }
                    &:hover {
                        background: #ffffff;
                        border: ${ELEMENTS.carouselArrows.border};
                    }
                    &:disabled {
                        display: none;
                    }
                `,
            },
        };
    }

    return baseStyles;
};

const styles = productCarouselStyles;

const SurCustomProductCarousel: React.FC<Props> = ({
    id,
    theme,
    fields,
    products,
    errorMessage,
    surLoadCarouselProductWithIds,
    // currentTab,
    pageType,
    shellContext,
}) => {
    const afterCarousel = React.createRef<HTMLSpanElement>();
    const isProductDetailsPage = pageType === "ProductDetailsPage";
    const isProductListPage = pageType === "ProductListPage";
    const isBrandDetailsPage = pageType === "BrandDetailsPage";
    const brand = React.useContext(BrandStateContext).value;
    const category = React.useContext(CategoryContext);
    const productContext = React.useContext(ProductContext);
    const itemArray = React.useMemo(() => {
        if (!fields.productidlist || fields.productidlist.trim() === "") {
            return [];
        }
        return fields.productidlist
            .split(",")
            .map(id => id.trim())
            .filter(Boolean);
    }, [fields.productidlist]);
    const isGlobalViewsTheme = React.useMemo(() => isThemeActive(THEME_IDS.GLOBAL_VIEWS), []);
    const styles = React.useMemo(() => getThemeAwareStyles(isGlobalViewsTheme), [isGlobalViewsTheme]);

    React.useEffect(() => {
        surLoadCarouselProductWithIds({
            carouselId: id,
            numberOfProductsToDisplay: fields.numberOfProductsToDisplay,
            isProductDetailsPage,
            productId: productContext?.product?.id,
            isProductListPage,
            category,
            isBrandDetailsPage,
            brand,
            productidlist: fields.productidlist,
        });
    }, [fields.numberOfProductsToDisplay, productContext?.product?.id, category?.id, brand?.id, fields.productidlist]);

    const [emblaRef, embla] = useEmblaCarousel();
    const [windowResizeTime, setWindowResizeTime] = React.useState(0);
    const [canScrollPrev, setCanScrollPrev] = React.useState(false);
    const [canScrollNext, setCanScrollNext] = React.useState(false);
    const [activeScroll, setActiveScroll] = React.useState(false);
    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };
    const [isTouchDevice, setIsTouchDevice] = React.useState(false);
    React.useEffect(() => {
        const checkIsTouch = () => {
            // Basic way to detect if touch is available
            setIsTouchDevice("ontouchstart" in window || navigator.maxTouchPoints > 0);
        };

        checkIsTouch();
        window.addEventListener("resize", checkIsTouch);
        return () => window.removeEventListener("resize", checkIsTouch);
    }, []);
    const getSlidesToScroll = React.useCallback(() => {
        const maxNumberOfColumns = fields.maxNumberOfColumns || 6;
        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let localSlidesToScroll: number;
        if (window.innerWidth < theme.breakpoints.values[1]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[2]) {
            localSlidesToScroll = 2;
        } else if (window.innerWidth < theme.breakpoints.values[3]) {
            localSlidesToScroll = 2;
        } else if (window.innerWidth < theme.breakpoints.values[4]) {
            localSlidesToScroll = isGlobalViewsTheme ? 3 : 4;
        } else if (window.innerWidth < theme.breakpoints.values[5]) {
            localSlidesToScroll = isGlobalViewsTheme ? 3 : 4;
        } else {
            localSlidesToScroll = isGlobalViewsTheme ? 3 : 4;
        }
        return Math.min(localSlidesToScroll, maxNumberOfColumns);
    }, [fields.maxNumberOfColumns, isGlobalViewsTheme]);

    const [slidesToScroll, setSlidesToScroll] = React.useState(getSlidesToScroll());

    const getDraggable = () => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < theme.breakpoints.values[1];
    };

    const [draggable, setDraggable] = React.useState(getDraggable());

    const isMobile = React.useMemo(() => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < theme.breakpoints.values[1];
    }, [windowResizeTime, theme.breakpoints.values[1]]);

    const onWindowResize = () => {
        setWindowResizeTime(Date.now());
    };
    React.useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();
        setSlidesToScroll(newSlidesToScroll);

        const newDraggable = getDraggable();
        setDraggable(newDraggable);
    }, [fields.maxNumberOfColumns, windowResizeTime]);

    React.useEffect(() => {
        if (!embla) {
            return;
        }
        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [embla]);
    // memoize slide width calculation to prevent recalculation on every render
    const slideWidth = React.useMemo(() => {
        if (isGlobalViewsTheme) {
            // mobile
            if (typeof window !== "undefined" && window.innerWidth < theme.breakpoints.values[1]) {
                return "calc(100% - 40px)";
            }
            // desktop
            if (slidesToScroll === 3) {
                return "calc(33.333% - 20px)";
            }
        }
        return `calc(100% / ${slidesToScroll})`;
    }, [isGlobalViewsTheme, slidesToScroll, theme.breakpoints.values]);

    React.useEffect(() => {
        if (!embla || !products || products.length === 0) {
            return;
        }

        embla.reInit({
            align:
                isGlobalViewsTheme && typeof window !== "undefined" && window.innerWidth < theme.breakpoints.values[1]
                    ? "center"
                    : "start",
            slidesToScroll,
            loop: isGlobalViewsTheme ? false : products.length > slidesToScroll,
            containScroll: "trimSnaps",
        });
        setCanScroll();
    }, [embla, slidesToScroll, draggable, products, activeScroll, isGlobalViewsTheme]);

    const productsKey = React.useMemo(() => products?.map(p => p.productNumber).join(",") ?? "", [products]);

    const sortedProduct = React.useMemo(() => {
        if (!itemArray || !products) {
            return [];
        }

        return itemArray
            .map(productNumber => products.find(item => item.productNumber === productNumber))
            .filter(Boolean);
    }, [itemArray, productsKey]);

    if (errorMessage && shellContext.isInShell) {
        return (
            <Typography {...styles.errorMessageText} as="p">
                {`Failed to load carousel products. Error: '${errorMessage}'. Please check widget settings.`}
            </Typography>
        );
    }

    if (!products || products.length === 0) {
        return null;
    }
    const showBrandBlocks = products.some(o => !!o.brand);
    const overriddenProps = { ...fields };

    return (
        <>
            <StyledWrapper
                {...styles.wrapper}
                {...(isTouchDevice
                    ? { onTouchStartCapture: () => setActiveScroll(true) }
                    : { onMouseMove: () => setActiveScroll(true) })}
            >
                <SkipNav
                    text={translate("Skip Carousel")}
                    extendedStyles={styles.skipCarouselButton}
                    destination={afterCarousel}
                />
                <StyledWrapper {...styles.customproducttilewrapper}>
                    <GridContainer {...styles.mainContainer} data-test-selector="productCarousel">
                        {!isGlobalViewsTheme && (
                            <GridItem {...styles.prevArrowGridItem}>
                                {products.length > slidesToScroll && (
                                    <Button
                                        {...styles.prevArrowButton}
                                        onClick={() => embla && embla.scrollPrev()}
                                        disabled={!canScrollPrev}
                                        data-test-selector="prevBtn"
                                    >
                                        <ButtonIcon src={CustomChevronLeft} />
                                    </Button>
                                )}
                            </GridItem>
                        )}
                        <GridItem {...styles.carouselGridItem}>
                            <StyledWrapper {...styles.carouselWrapper}>
                                {/* {!isGlobalViewsTheme && isMobile && products.length > slidesToScroll && (
                                        <>
                                            <StyledWrapper {...styles.prevArrowWrapper}>
                                                <Button
                                                    {...styles.prevArrowButton}
                                                    onClick={() => embla && embla.scrollPrev()}
                                                    disabled={!canScrollPrev}
                                                    data-test-selector="prevBtn"
                                                    aria-label="Previous slide"
                                                >
                                                    <ButtonIcon src={CustomChevronLeft} />
                                                </Button>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.nextArrowWrapper}>
                                                <Button
                                                    {...styles.nextArrowButton}
                                                    onClick={() => embla && embla.scrollNext()}
                                                    disabled={!canScrollNext}
                                                    data-test-selector="nextBtn"
                                                    aria-label="Next slide"
                                                >
                                                    <ButtonIcon src={CustomChevronRight} />
                                                </Button>
                                            </StyledWrapper>
                                        </>
                                    )} */}
                                {isGlobalViewsTheme && products.length > slidesToScroll && (
                                    <>
                                        <StyledWrapper {...styles.prevArrowWrapper}>
                                            <Button
                                                {...styles.prevArrowButton}
                                                onClick={() => embla && embla.scrollPrev()}
                                                disabled={!canScrollPrev}
                                                data-test-selector="prevBtn"
                                                aria-label="Previous slide"
                                            >
                                                <ButtonIcon src={GVLeftArrow} />
                                            </Button>
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.nextArrowWrapper}>
                                            <Button
                                                {...styles.nextArrowButton}
                                                onClick={() => embla && embla.scrollNext()}
                                                disabled={!canScrollNext}
                                                data-test-selector="nextBtn"
                                                aria-label="Next slide"
                                            >
                                                <ButtonIcon src={GVRightArrow} />
                                            </Button>
                                        </StyledWrapper>
                                    </>
                                )}
                                <StyledWrapper {...styles.carouselContainer} ref={emblaRef}>
                                    <StyledWrapper {...styles.carouselSlidesContainer} data-test-selector="slides">
                                        {sortedProduct?.map((product: any) => (
                                            <StyledWrapper
                                                {...styles.carouselSlide}
                                                key={product.id}
                                                style={{ width: slideWidth }}
                                            >
                                                <StyledWrapper
                                                    {...styles.carouselSlideInner}
                                                    id={`product_${product.id}`}
                                                    data-test-selector="productContainer"
                                                    className="related-productTile"
                                                >
                                                    <StyledWrapper
                                                        {...(isGlobalViewsTheme
                                                            ? styles.carouselItemWrapper
                                                            : styles.carouselProductWrapper)}
                                                    >
                                                        {isGlobalViewsTheme ? (
                                                            <div style={{ position: "relative" }}>
                                                                <SurProductListProductGridCrad
                                                                    carouselId={id}
                                                                    product={product}
                                                                    showImage={true}
                                                                    showBrand={false}
                                                                    showTitle={false}
                                                                    showPartNumbers={fields.showPartNumbers}
                                                                    showPrice={false}
                                                                    showAddToCart={false}
                                                                    showAddToList={fields.showAddToList}
                                                                    extendedStyles={styles.carouselProductStyles}
                                                                />
                                                                <StyledWrapper
                                                                    {...styles.carouselItemOverlay}
                                                                    className="carousel-item-overlay"
                                                                >
                                                                    <Typography {...styles.carouselItemTitle}>
                                                                        {product.productTitle ||
                                                                            product.shortDescription}
                                                                    </Typography>
                                                                    <StyledWrapper {...styles.carouselLearnMoreLink}>
                                                                        <StyledLearnMoreLink
                                                                            href={product.displayUrl}
                                                                            textColor="#FFFFFF"
                                                                            aria-label={`View Details about ${product.productTitle || product.shortDescription}`}
                                                                        >
                                                                            View Details
                                                                        </StyledLearnMoreLink>
                                                                    </StyledWrapper>
                                                                </StyledWrapper>
                                                            </div>
                                                        ) : (
                                                            <SurProductListProductGridCrad
                                                                carouselId={id}
                                                                product={product}
                                                                showImage={true}
                                                                showBrand={showBrandBlocks}
                                                                showTitle={true}
                                                                showPartNumbers={fields.showPartNumbers}
                                                                showPrice={false}
                                                                showAddToCart={false}
                                                                showAddToList={fields.showAddToList}
                                                                extendedStyles={styles.carouselProductStyles}
                                                            />
                                                        )}
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        ))}
                                    </StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>
                        </GridItem>
                        {!isGlobalViewsTheme && (
                            <GridItem {...styles.nextArrowGridItem}>
                                {products.length > slidesToScroll && (
                                    <Button
                                        {...styles.nextArrowButton}
                                        onClick={() => embla && embla.scrollNext()}
                                        disabled={!canScrollNext}
                                        data-test-selector="nextBtn"
                                    >
                                        <ButtonIcon src={CustomChevronRight} />
                                    </Button>
                                )}
                            </GridItem>
                        )}
                    </GridContainer>
                </StyledWrapper>

                <span ref={afterCarousel} tabIndex={-1} />
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withIsInShell(withTheme(SurCustomProductCarousel))),
    definition: {
        group: "Common",
        icon: "Carousel",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 0,
            },
            {
                name: fields.numberOfProductsToDisplay,
                displayName: "Number Of Products To Display",
                editorTemplate: "IntegerField",
                min: 1,
                max: 20,
                defaultValue: 10,
                fieldType: "General",
                sortOrder: 5,
            },
            {
                name: fields.showAddToList,
                displayName: "Add to Project",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                sortOrder: 15,
            },
            {
                name: fields.productidlist,
                displayName: "Product Ids",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 7,
            },
            {
                name: fields.maxNumberOfColumns,
                displayName: "Max Number Of Columns",
                editorTemplate: "IntegerField",
                min: 1,
                max: 6,
                defaultValue: 6,
                fieldType: "General",
                sortOrder: 8,
            },
        ],
    },
};

export default widgetModule;
